import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import logo from "../../Assets/PatientStatusSymbol/logo.svg";
import identity from "../../Assets/PatientStatusSymbol/identify.svg";
import healthArticle from "../../Assets/PatientStatusSymbol/health-artilce-logo.svg";
import wheelchair from "../../Assets/PatientStatusSymbol/wheelchair.svg";
import videocamera from "../../Assets/PatientStatusSymbol/videocamera.svg";
import home from "../../Assets/PatientStatusSymbol/home.svg";

import "./doctor.png";
import "./sideMenu.css";

import { useNavigate, useLocation } from "react-router-dom";
import strings from "../../utils/strings";
import Icons from "../../Assets/Icons";
import { useSelector } from "react-redux";

export default function SideMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [drop, setDrop] = useState("");
  const [openDropdown, setOpenDropdown] = useState(() => {
    return localStorage.getItem("openDropdown") || null;
  });
  const [openManageService, setOpenManageService] = useState(false);

  const privilege = useSelector((state) => state.verifyType.privilege);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes(strings.navigation.manageNurseReq)) {
      setOpenDropdown("nursing");
      setDrop("manage request");
    } else if (path.startsWith(strings.navigation.nurseList) || path.startsWith(strings.navigation.createNurse) || path.startsWith(strings.navigation.editNurse)) {
      setOpenDropdown("nursing");
      setDrop("manage nurse");
    } else if (path.startsWith(strings.navigation.additionalConsumableList) || path.startsWith(strings.navigation.addConsumable) || path.startsWith(strings.navigation.editConsumable)) {
      setOpenDropdown("nursing");
      setDrop("manage resource");
    } else if (path.startsWith(strings.navigation.manageServiceGroup)) {
      setOpenDropdown("nursing");
      setOpenManageService(true);
      setDrop("manageServiceGroup");
    } else if (path.startsWith(strings.navigation.manageSubServiceGroup)) {
      setOpenDropdown("nursing");
      setOpenManageService(true);
      setDrop("manageSubServiceGroup");
    } else if (path.startsWith(strings.navigation.manageServiceItem) || path.startsWith(strings.navigation.createService) || path.startsWith(strings.navigation.serviceDetail) || path.startsWith(strings.navigation.nursingCareManageService)) {
      setOpenDropdown("nursing");
      setOpenManageService(true);
      setDrop("manageServiceItem");
    } else if (path.startsWith(strings.navigation.additionalBilling) || path.startsWith(strings.navigation.additionalCostManagement)) {
      setOpenDropdown("nursing");
      setDrop("additional billing");
    } else if (path === "/department") {
      setOpenDropdown("video");
      setDrop("departments");
    } else if (path === "/department-price") {
      setOpenDropdown("video");
      setDrop("departmentPrice");
    } else if (path === "/patient-profile") {
      setOpenDropdown("patientProfile");
      setDrop("patientProfile");
    } else if (path === "/health-articles") {
      setOpenDropdown("healthArticles");
      setDrop("healthArticles");
    } else if (path === "/t&c_pp") {
      setOpenDropdown("tncPP");
      setDrop("tncPP");
    } else if (path === "/national-id") {
      setOpenDropdown("identityType");
      setDrop("identityType");
    } else if (path.startsWith(strings.navigation.manageTranspotationFees)) {
      setOpenDropdown("nursing");
      setDrop("manageTranspotationFees");
    } else if (path.startsWith(strings.navigation.patientHistory)) {
      setOpenDropdown("nursing");
      setDrop("patientHistory");
    }
  }, [location.pathname]);

  const handleManageRequest = () => {
    navigate(strings.navigation.manageNurseReq);
    setDrop("manage request");
  };

  const handleManageServiceToggle = () => {
    setOpenManageService(!openManageService);
  };

  const handleManageServiceGroup = () => {
    navigate(strings.navigation.manageServiceGroup);
    setDrop("manageServiceGroup");
  };

  const handleManageSubServiceGroup = () => {
    navigate(strings.navigation.manageSubServiceGroup);
    setDrop("manageSubServiceGroup");
  };

  const handleManageServiceItem = () => {
    navigate(strings.navigation.manageServiceItem);
    setDrop("manageServiceItem");
  };

  const handleManageNurse = () => {
    navigate(strings.navigation.nurseList);
    setDrop("manage nurse");
  };

  const handleManageResource = () => {
    navigate(strings.navigation.additionalConsumableList);
    navigate(strings.navigation.additionalConsumableList);
    setDrop("manage resource");
  };

  const handleManageTransportationFees = () => {
    navigate(strings.navigation.manageTranspotationFees);
    setDrop("manageTranspotationFees");
  };

  const handlePatientHistory = () => {
    navigate(strings.navigation.patientHistory);
    setDrop("patientHistory");
  };
  const handleAdditionalBilling = () => {
    navigate(strings.navigation.additionalCostManagement);
    setDrop("additional billing");
  };
  const handleSpecimenLogistics = () => {
    navigate(strings.navigation.specimenLogistics);
    setDrop("specimen logistics");
  };

  const handleClick = (dropdown) => {
    setOpenDropdown(dropdown);
    localStorage.setItem("openDropdown", dropdown);
  };

  const handlePatientProfile = () => {
    navigate("/patient-profile");
    setDrop("patientProfile");
  };
  const handleIdentityType = () => {
    navigate("/national-id");
    setDrop("nationalID");
  };

  const handleHealthArticles = () => {
    navigate("/health-articles");
    setDrop("healthArticles");
  };
  const handleTncPP = () => {
    navigate(strings.navigation.termsCondition);
    setDrop("tncPP");
  };

  const listButtonCss = (isOpen) => ({
    bgcolor: isOpen ? "#F0F0F0" : "",
    width: "94%",
    height: "5%",
    ml: "0.8rem",
    mb: "0.8rem",
    borderRadius: "8rem",
    textwrap: "nowrap",
    p: 1,
  });

  const dropdownButtonCss = (isActive) => ({
    ...listButtonCss(false),
    width: "20rem",
    height: "4rem",
    padding: "1rem",
    ml: "1rem",
    pl: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "1rem",
    whiteSpace: "nowrap",
    fontSize: "1.6rem",
    fontWeight: 400,
    lineHeight: "2rem",
    textAlign: "left",
    backgroundColor: isActive ? "#F0F0F0" : "transparent",
    position: "relative",
    "&::before": isActive ? {
      content: '""',
      position: "absolute",
      width: "0.8rem",
      height: "0.8rem",
      backgroundColor: "#00a854",
      left: "-1.45rem",
      borderRadius: "50%",
      zIndex: 1,
    } : {},
  });

  const handleDepartments = () => {
    navigate("/department");
    setDrop("departments");
  };

  const handlePrice = () => {
    navigate("/department-price");
    setDrop("departmentPrice");
  };

  return (
    <div className="sidebar" style={{ left: "0%" }}>
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>
      <List sx={{ width: "100%", mt: "2.8rem" }} component="nav" aria-labelledby="nested-list-subheader">
        {/* Patient Profile Section */}
        <ListItemButton
          sx={listButtonCss(openDropdown === "patientProfile")}
          onClick={() => {
            handleClick("patientProfile");
            handlePatientProfile();
          }}
          disableRipple
          disabled={!privilege?.hasPatientProfileRight}
        >
          <ListItemIcon>
            <img className="userIcon" src={wheelchair} alt="user" />
          </ListItemIcon>
          <ListItemText primary={t("patientProfile")} sx={{ ml: "-2.2rem" }} />
        </ListItemButton>
        <ListItemButton
          sx={listButtonCss(openDropdown === "identityType")}
          onClick={() => {
            handleClick("identityType");
            handleIdentityType();
          }}
          disableRipple
          disabled={!privilege?.hasNationalIdRight}
        >
          <ListItemIcon>
            <img className="userIcon" src={identity} alt="idenitfy" />
          </ListItemIcon>
          <ListItemText primary={t("identityType")} sx={{ ml: "-2.2rem" }} />
        </ListItemButton>

        <ListItemButton
          sx={listButtonCss(openDropdown === "healthArticles")}
          onClick={() => {
            handleClick("healthArticles");
            handleHealthArticles();
          }}
          disableRipple
          disabled={!privilege?.hasArticleRight}
        >
          <ListItemIcon>
            <img className="userIcon" src={healthArticle} alt="Health Articles" />
          </ListItemIcon>
          <ListItemText primary={t("healthArt")} sx={{ ml: "-2.2rem" }} />
        </ListItemButton>

        {/* Nursing Section */}
        <ListItemButton sx={listButtonCss(openDropdown === "nursing")} onClick={() => handleClick("nursing")} disableRipple disabled={!privilege?.hasHomeCareRight}>
          <ListItemIcon>
            <img className="userIcon" src={home} alt="user" />
          </ListItemIcon>
          <ListItemText primary={t("nursingCare")} sx={{ ml: "-2.2rem" }} />
          {openDropdown === "nursing" ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openDropdown === "nursing"} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ borderLeft: "0.1rem solid #a3a3a3", ml: "2rem", mt: "0.8rem", mb: "1.2rem" }}>
            <ListItemButton sx={dropdownButtonCss(drop === "manage request")} onClick={handleManageRequest} disableRipple>
              <ListItemText primary={t("manageRequests")} />
            </ListItemButton>

            <ListItemButton sx={dropdownButtonCss(openManageService || drop.startsWith("manageService"))} onClick={handleManageServiceToggle} disableRipple>
              <ListItemText primary={t("manageService")} />
              {openManageService ? <ExpandLess sx={{ ml: "auto" }} /> : <ExpandMore sx={{ ml: "auto" }} />}
            </ListItemButton>
            <Collapse in={openManageService} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ borderLeft: "0.1rem solid #a3a3a3", ml: "4rem", mt: "0.8rem", mb: "1.2rem" }}>
                <ListItemButton sx={dropdownButtonCss(drop === "manageServiceGroup")} onClick={handleManageServiceGroup} disableRipple>
                  <ListItemText primary={t("manageServiceGroup") || "Manage Service Group"} />
                </ListItemButton>
                <ListItemButton sx={dropdownButtonCss(drop === "manageSubServiceGroup")} onClick={handleManageSubServiceGroup} disableRipple>
                  <ListItemText primary={t("manageSubServiceGroup") || "Manage Sub-Service Group"} />
                </ListItemButton>
                <ListItemButton sx={dropdownButtonCss(drop === "manageServiceItem")} onClick={handleManageServiceItem} disableRipple>
                  <ListItemText primary={t("manageServiceItem") || "Manage Service Item"} />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton sx={dropdownButtonCss(drop === "manage nurse")} onClick={handleManageNurse} disableRipple>
              <ListItemText primary={t("manageNurse")} />
            </ListItemButton>
            <ListItemButton sx={dropdownButtonCss(drop === "manage resource")} onClick={handleManageResource} disableRipple>
              <ListItemText primary={t("manageResource")} />
            </ListItemButton>
            <ListItemButton sx={dropdownButtonCss(drop === "manageTranspotationFees")} onClick={handleManageTransportationFees} disableRipple>
              <ListItemText primary={t("transportationFee")} />
            </ListItemButton>
            <ListItemButton sx={dropdownButtonCss(drop === "patientHistory")} onClick={handlePatientHistory} disableRipple>
              <ListItemText primary={t("patientHistory")} />
            </ListItemButton>
            <ListItemButton sx={dropdownButtonCss(drop === "additional billing")} onClick={handleAdditionalBilling} disableRipple>
              <ListItemText primary={t("additionalBilling")} />
            </ListItemButton>
            <ListItemButton sx={dropdownButtonCss(drop === "specimen logistics")} onClick={handleSpecimenLogistics} disableRipple>
              <ListItemText primary={t("specimenLogistics")} />
            </ListItemButton>
          </List>
        </Collapse>

        {/* Video Section */}
        <ListItemButton sx={listButtonCss(openDropdown === "video")} onClick={() => handleClick("video")} disableRipple disabled={!privilege?.hasDepartmentRight}>
          <ListItemIcon>
            <img className="userIcon" src={videocamera} alt="user" />
          </ListItemIcon>
          <ListItemText primary={t("manageVideoDept")} sx={{ ml: "-2.2rem" }} />
          {openDropdown === "video" ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openDropdown === "video"} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ borderLeft: "0.1rem solid #a3a3a3", ml: "2rem", mt: "0.8rem", mb: "1.2rem" }}>
            <ListItemButton sx={dropdownButtonCss(drop === "departments")} disableRipple onClick={handleDepartments}>
              <ListItemText primary={t("departments")} />
            </ListItemButton>
            <ListItemButton sx={dropdownButtonCss(drop === "departmentPrice")} disableRipple onClick={handlePrice}>
              <ListItemText primary={t("departmentPrice")} />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton
          sx={listButtonCss(openDropdown === "tncPP")}
          onClick={() => {
            handleClick("tncPP");
            handleTncPP();
          }}
          disableRipple
          disabled={!privilege?.hasTNCright}
        >
          <ListItemIcon>
            <img className="userIcon" src={Icons.tncPP} alt="Health Articles" />
          </ListItemIcon>
          <ListItemText primary={t("tncPP")} sx={{ ml: "-2.2rem" }} />
        </ListItemButton>
      </List>
    </div>
  );
}
